

      <mat-toolbar>
        <span>Manage Accounts</span>
        <span class="fill-remaining-space"></span>
        <button class="btn-dialog-close" mat-stroked-button (click)="onClose()"><mat-icon>clear</mat-icon></button>
      </mat-toolbar>
    
      <form  [formGroup] ="bankAccountForm"  autocomplete="off" (ngSubmit)="saveButtonClick()" class="form-horizontal">
      <mat-grid-list cols="1" rowHeight="400px">
        <mat-grid-tile>
        <div class="controles-container"> 
          <input  type="hidden" formControlName="id" readonly> 
            <mat-form-field>
            <input  type="text" formControlName="accountName" [readonly]="readOnlyField" matInput placeholder="Account Name"> 
            <mat-error>Account Name is required</mat-error>                               
            </mat-form-field>
       
            <mat-form-field>
            <input  type="text" formControlName="bank" matInput placeholder="Bank Name">   
            <mat-error>Bank Name is required</mat-error>    
            </mat-form-field>

            <mat-form-field>
            <input type="text" formControlName="accountNo" matInput placeholder="Account Number (Optional)">     
            </mat-form-field>

            <mat-form-field>
            <input  type="text" formControlName="openingBal" matInput placeholder="Opening Balance">                    
            </mat-form-field>
   
            <mat-form-field>
              <input  formControlName="openingBalDate" matInput [matDatepicker]="picker" placeholder="Date">
              <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>   

            <div class="button-row">
              <button *ngIf="crud_access.create"  type="submit" mat-raised-button color="primary" class="mr-2">
                <span *ngIf ="showProcessingIndicator" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                Save
              </button> 
                <button type="button" mat-raised-button color="warn" (click)="clearButtonClick()">Clear</button>                 
              </div>

          </div>
        </mat-grid-tile>
      </mat-grid-list>
    </form>


             